import { ColumnProps } from "@monolith-forensics/monolith-ui";

import { monolithMoment } from "@/utils/date-format";

import { SavedReportActionsCell } from "../Components/SavedReportActionsCell";
import { SavedReport } from "../savedReports.types";

interface SavedReportColumnOptions {
  canManage: boolean;
  onDelete: (report: SavedReport) => void;
}

export const getSavedReportColumnDefs = ({
  canManage,
  onDelete,
}: SavedReportColumnOptions): ColumnProps[] => [
  { dataField: "name", caption: "Report", enableSorting: true },
  {
    dataField: "created_on",
    caption: "Created On",
    dataType: "date",
    width: 200,
    enableSorting: true,
    // Date only, in the user's date format
    render: ({ rowData }) => monolithMoment({ timestamp: rowData.created_on }),
  },
  {
    dataField: "created_by",
    caption: "Created By",
    width: 200,
    enableSorting: true,
  },
  {
    dataField: "actions",
    caption: "",
    width: 225,
    enableSorting: false,
    enableResize: false,
    render: ({ rowData }) => (
      <SavedReportActionsCell
        report={rowData}
        canManage={canManage}
        onDelete={onDelete}
      />
    ),
  },
];
